import { render, staticRenderFns } from "./CoursesGroupsBlock.vue?vue&type=template&id=d0cd9756&scoped=true&"
import script from "./CoursesGroupsBlock.vue?vue&type=script&lang=ts&"
export * from "./CoursesGroupsBlock.vue?vue&type=script&lang=ts&"
import style0 from "./CoursesGroupsBlock.vue?vue&type=style&index=0&id=d0cd9756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd9756",
  null
  
)

export default component.exports